export const AUTH_START = 'AUTH_START'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_FAIL = 'AUTH_FAIL'
export const AUTH_REFRESH = 'AUTH_REFRESH'


export const REGISTER_START = 'REGISTER_START'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAIL = 'REGISTER_FAIL'
export const REGISTER_REFRESH = 'REGISTER_REFRESH'


export const GET_COMPANY_START = 'GET_COMPANY_START'
export const GET_COMPANY_SUCCESS = 'GET_COMPANY_SUCCESS'
export const GET_COMPANY_FAIL = 'GET_COMPANY_FAIL'
export const GET_COMPANY_REFRESH = 'GET_COMPANY_REFRESH'

export const GET_STATE_START = 'GET_STATE_START'
export const GET_STATE_SUCCESS = 'GET_STATE_SUCCESS'
export const GET_STATE_FAIL = 'GET_STATE_FAIL'
export const GET_STATE_REFRESH = 'GET_STATE_REFRESH'

export const GET_LGA_START = 'GET_LGA_START'
export const GET_LGA_SUCCESS = 'GET_LGA_SUCCESS'
export const GET_LGA_FAIL = 'GET_LGA_FAIL'
export const GET_LGA_REFRESH = 'GET_LGA_REFRESH'

export const GET_MEASUREMENT_START = 'GET_MEASUREMENT_START'
export const GET_MEASUREMENT_SUCCESS = 'GET_MEASUREMENT_SUCCESS'
export const GET_MEASUREMENT_FAIL = 'GET_MEASUREMENT_FAIL'
export const GET_MEASUREMENT_REFRESH = 'GET_MEASUREMENT_REFRESH'

export const GET_UNIT_MEASUREMENT_START = 'GET_UNIT_MEASUREMENT_START'
export const GET_UNIT_MEASUREMENT_SUCCESS = 'GET_UNIT_MEASUREMENT_SUCCESS'
export const GET_UNIT_MEASUREMENT_FAIL = 'GET_UNIT_MEASUREMENT_FAIL'
export const GET_UNIT_MEASUREMENT_REFRESH = 'GET_UNIT_MEASUREMENT_REFRESH'

export const GET_MEASUREMENT_CAPACITY_START = 'GET_MEASUREMENT_CAPACITY_START'
export const GET_MEASUREMENT_CAPACITY_SUCCESS = 'GET_MEASUREMENT_CAPACITY_SUCCESS'
export const GET_MEASUREMENT_CAPACITY_FAIL = 'GET_MEASUREMENT_CAPACITY_FAIL'
export const GET_MEASUREMENT_CAPACITY_REFRESH = 'GET_MEASUREMENT_CAPACITY_REFRESH'

export const ADD_INSTRUMENT_START = 'ADD_INSTRUMENT_START'
export const ADD_INSTRUMENT_SUCCESS = 'ADD_INSTRUMENT_SUCCESS'
export const ADD_INSTRUMENT_FAIL = 'ADD_INSTRUMENT_FAIL'
export const ADD_INSTRUMENT_REFRESH = 'ADD_INSTRUMENT_REFRESH'

export const GET_REGISTERED_INSTRUMENT_START = 'GET_REGISTERED_INSTRUMENT_START'
export const GET_REGISTERED_INSTRUMENT_SUCCESS = 'GET_REGISTERED_INSTRUMENT_SUCCESS'
export const GET_REGISTERED_INSTRUMENT_FAIL = 'GET_REGISTERED_INSTRUMENT_FAIL'
export const GET_REGISTERED_INSTRUMENT_REFRESH = 'GET_REGISTERED_INSTRUMENT_REFRESH'

export const GET_BILLS_START = 'GET_BILLS_START'
export const GET_BILLS_SUCCESS = 'GET_BILLS_SUCCESS'
export const GET_BILLS_FAIL = 'GET_BILLS_FAIL'
export const GET_BILLS_REFRESH = 'GET_BILLS_REFRESH'


export const LOG_OUT = 'LOG_OUT';

export const UPDATE_BREADCRUMBS = 'UPDATE_BREADCRUMBS';
export const TOGGLE_BREADCRUMBS = 'TOGGLE_BREADCRUMBS';
